export const Team = () => <></>